import React, { useState, useEffect, useRef, useContext } from 'react';
import { Container, Row, Col, Form, Toast, Button, Spinner, Navbar, Tooltip, OverlayTrigger, Badge } from 'react-bootstrap';
import { ProjectColors } from '../../Enums/Core/projectColors';
import Dropdown, { components } from 'react-select';
import { Multiselect } from 'multiselect-react-dropdown';
import { DateTime } from "luxon";
import useSound from 'use-sound';
import notificationSfx from '../../Sounds/Notification.mp3';
import { GoMute } from 'react-icons/go';
import { VscSettings } from "react-icons/vsc";
import { GoUnmute } from 'react-icons/go';
import { store } from "../../Store/store";
import './MonitoringPage.css';
import 'react-dropdown/style.css';
import AlertsTable from "../../Components/AlertsTable/AlertsTable";
import { MonitoringService } from "./MonitoringService";
import { SupportUsersService } from "../../General/SupportUsersService";
import { RiArrowDownSFill } from "react-icons/ri";
import moment from "moment/moment";
import ColorsLegendModal from "./ColorsLegendModal";
import { CgList } from "react-icons/cg";
import { defaultSystemStates } from "../../General/SystemLifeCycleStates";

export default function MonitoringPage() {
    const isMountedValue = useRef(false);
    const [isMounted, setIsMounted] = useState(isMountedValue.current);
    const tierFilterValue = useRef(null);
    const timeFilterValue = useRef(null);
    const usersFilterValue = useRef(null);
    const hideClosedEventsValue = useRef(true);
    const countriesFilterValue = useRef([]);
    const _organizations = useRef([]);
    const eventAssigneesData = useRef({});
    const allMonitoringData = useRef([]);
    const [assignedAlertsData, setAssignedAlertsData] = useState({});
    const [hideClosedEvents, setHideClosedEvents] = useState(hideClosedEventsValue.current);
    const [alertTableData, setAlertTableData] = useState(null);
    const [tierFilter, setTierFilter] = useState(tierFilterValue.current);
    const [timeFilter, setTimeFilter] = useState(timeFilterValue.current);
    const [usersFilter, setUsersFilter] = useState(usersFilterValue.current);
    const [countriesFilter, setCountriesFilter] = useState(countriesFilterValue.current);
    const [countriesDropDownOptions, setCountriesDropDownOptions] = useState([]);
    const [confirmationFilterOptions, setConfirmationFilterOptions] = useState([]);
    const [reasonChanged, setReasonChanged] = useState([]);
    const [reasonsOptions, setReasonsOptions] = useState([]);
    let confirmationData = [];
    const [showPopup, setShowPopup] = useState(false);
    const [notificationSound] = useSound(notificationSfx);
    const isMutedValue = useRef(false);
    const loadedClosedEventsValue = useRef(false);
    const [loadedClosedEvents, setLoadedClosedEvents] = useState(loadedClosedEventsValue.current);
    const [isMuted, setIsMuted] = useState(isMutedValue.current);
    const _refreshRate = 60000;
    const monitoringService = new MonitoringService(process.env.REACT_APP_SUPPORT_DASHBOARD_LEAKS_URL);
    const supportUsersService = new SupportUsersService(process.env.REACT_APP_SUPPORT_DASHBOARD_USERS_URL);
    const [fadingOut, setFadingOut] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isRefreshActive, setIsRefreshActive] = useState(true);
    const stateObj = useContext(store);
    const isRequestInProgress = stateObj.state.isRequestInProgress;
    const [queryTime, setQueryTime] = useState(null);
    const [intervalId, setIntervalId] = useState();
    const [supportUsers, setSupportUsers] = useState([]);
    const [clmShow, setClmShow] = useState(false);
    const NOT_FOUND = -1;
    const [selectedSystemStates, setSelectedSystemStates] = useState(defaultSystemStates);
    const [isInitRequestInProgress, setIsInitRequestInProgress] = useState(false);

    const [countdown, setCountdown] = useState(_refreshRate / 1000); // Initialize countdown with refresh rate in seconds
    const [showRefreshBadge, setShowRefreshBadge] = useState(false); // State to control badge visibility

    const customDropdownStyles = {
        control: (provided, state) => ({
            width: 200,
            height: 41,
            ...provided
        })
    }
    const DropdownIndicator = props => {
        return (components.DropdownIndicator && (<components.DropdownIndicator {...props}>
            <RiArrowDownSFill color={'black'} size={20}/>
        </components.DropdownIndicator>));
    };

    const verticalLineStyle = {
        width: '1px', height: '36px', float: 'left', backgroundColor: 'rgba(0,0,0,.5)', margin: '5px'
    };

    const reasonsArr = [
        {id: 1, text: '', confirmation: "UNKNOWN"},
        {id: 2, text: "Burst pipe", confirmation: "CONFIRMED_LEAK"},
        {id: 3, text: "Running toilet", confirmation: "CONFIRMED_LEAK"},
        {id: 4, text: "Open tap", confirmation: "CONFIRMED_LEAK"},
        {id: 5, text: "Unknown alert cause", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 6, text: "Other", confirmation: "CONFIRMED_LEAK"},
        {id: 7, text: "Background flow", confirmation: "CONFIRMED_LEAK"},
        {id: 8, text: "Drip", confirmation: "CONFIRMED_LEAK"},
        {id: 9, text: "Stuck float valve", confirmation: "CONFIRMED_LEAK"},
        {id: 10, text: "Bug", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 11, text: "Incorrect meter configuration", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 12, text: "Incorrect algo thresholds", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 13, text: "Legitimate high usage", confirmation: "CONFIRMED_FALSE_ALERT"},
        {id: 14, text: "Incorrect policy parameters", confirmation: "CONFIRMED_FALSE_ALERT"}
    ];

    const confirmations = [
        {id: 0, value: 'UNKNOWN'},
        {id: 1, value: 'CONFIRMED_LEAK'},
        {id: 2, value: 'CONFIRMED_FALSE_ALERT'}
    ];

    const severityLevels = [
        {value: 'MAJOR', label: 'Major'},
        {value: 'MODERATE', label: 'Moderate'},
        {value: 'MINOR', label: 'Minor'}
    ];

    const handleOnEdit = (state) => {
        setIsEditing(state);
    }

    const timeDropDownOptions = [{value: null, label: 'All Time'}, {
        value: DateTime.local(DateTime.local().year, DateTime.local().month, DateTime.local().day, 0, 0, 0),
        label: 'Last Day'
    }, {
        value: DateTime.local(DateTime.local().year, DateTime.local().month, DateTime.local().day, 0, 0, 0).minus({days: DateTime.local().weekday}),
        label: 'Last Week'
    }, {value: DateTime.local(DateTime.local().year, DateTime.local().month, 1, 0, 0, 0), label: 'Last Month'}];

    const isValueInArray = (value, array, property) => {
        let results = array.filter(obj => {
            return value === obj[property];
        });
        return (results.length > 0);
    }

    const getCurrentUtcTime = () => {
        const currentDate = new Date();
        const utcTimestamp = new Date().getTime();
        currentDate.setTime(utcTimestamp);
        return currentDate.toISOString().slice(0, -5);
    }

    const getEventHistoryDataFromDB = async (isFromInterval, selectedSystemStatesValues) => {
        setIsInitRequestInProgress(true);
        await monitoringService.getActiveLeaks(selectedSystemStatesValues).then(res => {
            setQueryTime(getCurrentUtcTime());
            let response = res.data;
            if (!response) {
                console.error('Data from EventHistoryOpenLeaks is empty');
                return;
            }
            allMonitoringData.current = response;
            hideClosedEventsValue.current = false;
            loadedClosedEventsValue.current = true;
            setLoadedClosedEvents(true);
            setIsInitRequestInProgress(false);
        }).catch(err => {
            setIsInitRequestInProgress(false);
            console.error(err);
        });
    }

    const getLastEventDataFromDB = async () => {
        let isNewLeakAvailable = false;
        let res = await monitoringService.getLastActiveLeaks(queryTime, selectedSystemStates);
        let response = res.data;
        setQueryTime(getCurrentUtcTime());
        response.forEach(responseObj => {
            let index = allMonitoringData.current.findIndex(currentDataObj => currentDataObj.id === responseObj.id);
            if (index === NOT_FOUND && (responseObj.closed === false || responseObj.closed === null)) {
                const duplicateIndices = allMonitoringData.current.reduce((indices, currentDataObj, idx) => {
                    if (currentDataObj.waterSystem?.id === responseObj.waterSystem?.id && 
                        currentDataObj.flowRateType === responseObj.flowRateType &&
                        (currentDataObj.closed === false || currentDataObj.closed === null)) {
                        indices.push(idx);
                    }
                    return indices;
                }, []);

                if (duplicateIndices.length > 0) {
                    duplicateIndices.sort((a, b) => b - a);
                    duplicateIndices.forEach(idx => {
                        allMonitoringData.current.splice(idx, 1);
                    });
                }

                allMonitoringData.current.push(responseObj);
                isNewLeakAvailable = true;
            }
            if (index !== NOT_FOUND) {
                if (responseObj.closed) {
                    allMonitoringData.current.splice(index, 1);
                } else {
                    allMonitoringData.current[index] = responseObj;
                }
            }
        })
        initAllCharts(allMonitoringData.current);
        if (isNewLeakAvailable) {
            setShowPopup(true);
        }
    }

    const getCountries = async (date) => {
        let countries = [];
        try {
            const response = await monitoringService.getCountries(date);
            response.data.forEach(country => {
                countries.push({value: country, label: country});
            })
            setCountriesDropDownOptions(countries);
        } catch (err) {
            console.error(err);
        }
    }

    const getSeverityLevel = (level) => {
        const result = severityLevels.filter((obj) => obj.value === level);
        return result[0] ? result[0].label : '';
    }

    const initAllCharts = (data) => {
        initAlertTable(data);
    }

    const shouldEventAppear = (event) => {
        // If there's an active Time filter, check if the current event didn't occur during that filter
        if (timeFilterValue?.current?.value && timeFilterValue?.current?.value?.ts > DateTime.fromISO(event.lastEventTime).ts) return false;

        // If there's an active Country filter, check if the current event occurred in that country
        if (countriesFilterValue.current?.length > 0 && !isValueInArray(event.country, countriesFilterValue.current, 'value')) return false;

        return true;
    }

    const initAssignedAlerts = (data) => {
        let assignedAlertsData = {
            categories: ['Major', 'Moderate', 'Minor'], data: [{
                name: 'Unassigned Tier 1',
                data: [0, 0, 0],
                stack: 'Tier1',
                color: ProjectColors.LightPurple,
                showInLegend: false
            }, {
                name: 'Unassigned Tier 2',
                data: [0, 0, 0],
                stack: 'Tier2',
                color: ProjectColors.LightBlue,
                showInLegend: false
            }, {
                name: 'Unassigned Tier 3',
                data: [0, 0, 0],
                stack: 'Tier3',
                color: ProjectColors.LightPink,
                showInLegend: false
            }, {
                name: 'Unassigned Tier 4',
                data: [0, 0, 0],
                stack: 'Tier4',
                color: ProjectColors.LightTeal,
                showInLegend: false
            }, {
                name: 'Tier 1', data: [0, 0, 0], stack: 'Tier1', color: ProjectColors.Purple
            }, {
                name: 'Tier 2', data: [0, 0, 0], stack: 'Tier2', color: ProjectColors.Blue
            }, {
                name: 'Tier 3', data: [0, 0, 0], stack: 'Tier3', color: ProjectColors.Pink
            }, {
                name: 'Tier 4', data: [0, 0, 0], stack: 'Tier4', color: ProjectColors.Teal
            }]
        };

        data.forEach((event) => {
            let orgId, innerType;

            if (!shouldEventAppear(event)) return;

            // If there's an active User filter, check if the current event isn't assigned to the selected user
            if (usersFilterValue.current?.length > 0 && !isValueInArray(eventAssigneesData.current[event.id]?.userId, usersFilterValue.current, 'value')) return;

            // Determine if the current Event has an Organization allocated
            if (!event.orgId || !_organizations.current[event.orgId] || !_organizations.current[event.orgId].tier) {
                orgId = 19; // Private Customers
            } else {
                orgId = event.orgId;
            }

            innerType = Math.min(event.innerType, 2);

            // If the event is assigned
            if (eventAssigneesData.current[event.id] && eventAssigneesData.current[event.id].userId !== null) {
                let barIndex = _organizations.current[orgId].tier - 1 + 4; // Added 4 to get the correct Assigned index
                assignedAlertsData.data[barIndex].data[innerType]++;
            } else {
                let barIndex = _organizations.current[orgId].tier - 1;
                assignedAlertsData.data[barIndex].data[innerType]++;
            }
        })

        setAssignedAlertsData(assignedAlertsData)
    }

    const formatDate = (date) => {
        if (!date) {
            return '';
        }
        const formattedString = moment(date).local().format('lll');
        return formattedString === 'Invalid date' ? '' : formattedString;
    }

    const initAlertTable = (data) => {
        let alertTableData = [];
        data.forEach(event => {
            if (!shouldEventAppear(event)) return;
            alertTableData.push({
                id: event.id,
                waterSystemId: event.waterSystem.id,
                waterSystem: event.waterSystem.name,
                organizationId: event.organization.id,
                account: event.organization.name,
                siteId: event.site.id,
                site: event.site.name,
                duration: event.leakStats.duration,
                leakConsumption: event.leakConsumption,
                initialFlowRate: event.leakStats.initialFlowrate,
                flowRatePerHour:event.leakStats.flowrate,
                tier: event.tier,
                severity: getSeverityLevel(event.flowRateType),
                leakHighlight: event.leakHighlight,
                valveStatus: event.valveStatus,
                leakAlerts: event.alert,
                other: event.other,
                lastEventTime: formatDate(event.lastEventTime),
                assignmentIndex: eventAssigneesData.current[event.id]?.index,
                assignee: event.assignee === null ? 0 : event.assignee,
                assignDate: event.updated,
                linkToSalesForce: event.linkToSalesforce,
                remarks: event.remarks === null ? '' : event.remarks,
                communication: event.communication ? event.communication : {
                    call: false,
                    message: false,
                    email: false
                },
                commMethodsAsBitfield: event.communication,
                confirmation: getConfirmation(event.confirmation),
                reason: getReasonId(event.reason),
                bgColor: null
            })
        });

        setAlertTableData(alertTableData);
    }

    const getReasonId = (reason) => {
        if (!reason) {
            return 1;
        }
        let readableText = reason.replaceAll('_', ' ').toLowerCase();
        readableText = reason.charAt(0) + readableText.slice((1));
        const result = reasonsArr.filter((obj) => obj.text === readableText);
        return result[0] ? result[0].id : 1;
    }

    const getConfirmation = (confirmation) => {
        const result = confirmations.filter((obj) => obj.value === confirmation);
        return result[0] ? result[0].id : 0;
    }

    const getSupportUsers = () => {
        const requestSupportUsers = supportUsersService.getAllUsers();
        requestSupportUsers.then(response => {
            setSupportUsers(response);
        })
    }

    // Handle Assigned Chart Time Filter
    useEffect(() => {
        timeFilterValue.current = timeFilter;

        if (isMountedValue.current) {
            initAllCharts(allMonitoringData.current);
        }
    }, [timeFilter])

    // Handle Assigned Chart User Filter
    useEffect(() => {
        usersFilterValue.current = usersFilter;

        if (isMountedValue.current && usersFilter) {
            initAssignedAlerts(allMonitoringData.current);
        }
    }, [usersFilter])

    // Handle Countries Filter value change
    useEffect(() => {
        countriesFilterValue.current = countriesFilter;

        if (isMountedValue.current) {
            initAllCharts(allMonitoringData.current);
        }
    }, [countriesFilter])


    const getAllData = async (isFromInterval, selectedSystemStatesValue) => {
        let confirmations = [];
        let reasons = [];
        await getCountries();
        reasonsArr.forEach(reason => {
            let value = 0;
            if (reason.confirmation === "CONFIRMED_LEAK") {
                value = 1;
            } else if (reason.confirmation === "CONFIRMED_FALSE_ALERT") {
                value = 2;
            }
            const label = reason.confirmation.replaceAll('_', ' ').toLowerCase();
            confirmations.push({
                id: reason.id, value: value, label: reason.confirmation.charAt(0) + label.slice((1)), text: reason.text
            });
            reasons.push({confirmationValue: value, label: reason.text, value: reason.text});
        })
        setConfirmationFilterOptions(confirmations);
        setReasonsOptions(reasons);
        confirmationData = confirmations;
        await getEventHistoryDataFromDB(isFromInterval, selectedSystemStatesValue);
        initAllCharts(allMonitoringData.current);

        isMountedValue.current = true;
        setIsMounted(true);
    }

    useEffect(() => {
        getSupportUsers();
    }, []);

    useEffect(() => {
        if (showPopup && !isMuted) notificationSound();
    }, [showPopup]);

    useEffect(() => {
        getAllData(false, selectedSystemStates);
    }, [reasonChanged]);

    useEffect(() => {
        if (isRefreshActive) {
            let intervalIdNum = setInterval(async () => {
                await getLastEventDataFromDB();
            }, _refreshRate);
            setIntervalId(intervalIdNum);
        } else {
            clearInterval(intervalId);
        }
    }, [isRefreshActive, queryTime, selectedSystemStates]);

    useEffect(() => {
        let logInterval;

        if (isRefreshActive) {
            console.log('Starting countdown from beginning...');
            setCountdown(_refreshRate / 1000);

            logInterval = setInterval(() => {
                setCountdown((prevCountdown) => {
                    if (prevCountdown > 1) {
                        if (prevCountdown <= 6) {
                            setShowRefreshBadge(true);
                        } else {
                            setShowRefreshBadge(false);
                        }
                        console.log('Seconds left until next refresh:', prevCountdown - 1);
                        return prevCountdown - 1;
                    } else {
                        console.log('Refreshing data now...');
                        setShowRefreshBadge(false);
                        return _refreshRate / 1000;
                    }
                });
            }, 1000);
        } else {
            console.log('Stopping countdown.');
        }

        return () => {
            if (logInterval) {
                console.log('Clearing countdown interval.');
                clearInterval(logInterval);
            }
        };
    }, [isRefreshActive]);

    useEffect(() => {
        clearInterval(intervalId);
    }, [queryTime, selectedSystemStates]);

    useEffect(() => {
        !isEditing && !(isRequestInProgress?.state) ? setIsRefreshActive(true) : setIsRefreshActive(false);
    }, [isEditing, isRequestInProgress]);

    const toggleMute = () => {
        isMutedValue.current = !isMutedValue.current;
        setIsMuted(isMutedValue.current);
    }

    if (supportUsers.length > 0) {
        return (
            <Container fluid>
                {/* ================= Refresh Countdown Badge ================= */}
                {showRefreshBadge && (
                    <div className="refresh-badge">
                        <Badge bg="info" pill>
                            Page refresh in {countdown} seconds
                        </Badge>
                    </div>
                )}

                {/* ================= New Alerts PopUp ================= */}
                <Row style={{ padding: "3px", zIndex: 20 }}>
                    <Col xs={6}>
                        <Toast
                            autohide={true}
                            delay={5000}
                            show={showPopup}
                            onClose={() => setShowPopup(false)}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                margin: '5px',
                                color: "white",
                                backgroundColor: ProjectColors.Red,
                                zIndex: 100
                            }}>
                            <Toast.Body><strong>New alerts are available</strong></Toast.Body>
                        </Toast>
                    </Col>
                </Row>
                <Container fluid>
                    <br />
                    <Col>
                        <Row>
                            <Col>
                                <Navbar bg="light">
                                    <Container fluid>
                                        <Navbar.Brand><VscSettings className='mr-2' />Display Options</Navbar.Brand>
                                        <hr className='mr-2' style={verticalLineStyle} />
                                        <Navbar.Collapse>
                                            <ul className="navbar-nav">
                                                <li className="nav-item mt-2">
                                                    {(!hideClosedEvents && !loadedClosedEvents) &&
                                                        <Spinner size="sm" animation="border" variant="primary" />}
                                                </li>
                                                <li className="nav-item ml-5 mt-0">
                                                    <Dropdown
                                                        styles={customDropdownStyles}
                                                        options={timeDropDownOptions}
                                                        onChange={async (timeFilter) => {
                                                            if (timeFilter.value) {
                                                                let date = new Date(timeFilter.value.ts).toISOString().slice(0, -5);
                                                                await getCountries(date);
                                                            } else {
                                                                await getCountries(null);
                                                            }
                                                            setTimeFilter(timeFilter);
                                                        }}
                                                        disabled={!isMounted}
                                                        value={timeFilter}
                                                        components={{
                                                            IndicatorSeparator: () => null, DropdownIndicator
                                                        }}
                                                        placeholder="All Time" />
                                                </li>
                                                <li className="nav-item ml-5">
                                                    <Multiselect
                                                        options={countriesDropDownOptions}
                                                        selectedValues={countriesFilter}
                                                        style={{
                                                            chips: {
                                                                visibility: 'hidden', position: 'absolute', zIndex: -1000
                                                            }, searchBox: {
                                                                backgroundColor: 'white'
                                                            }
                                                        }}
                                                        showCheckbox
                                                        showArrow={true}
                                                        placeholder={countriesFilter?.length > 0 ? `${countriesFilter.length} Selected` : 'All Countries'}
                                                        closeOnSelect={true}
                                                        hidePlaceholder={false}
                                                        disable={!isMounted}
                                                        avoidHighlightFirstOption={true}
                                                        onSelect={(selectedList) => setCountriesFilter(selectedList)}
                                                        onRemove={(selectedList) => setCountriesFilter(selectedList)}
                                                        displayValue="label" />
                                                </li>
                                            </ul>
                                        </Navbar.Collapse>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip>Color Legend</Tooltip>
                                            }>
                                            <Button variant="light" onClick={() => setClmShow(true)}><CgList /></Button>
                                        </OverlayTrigger>
                                        <ColorsLegendModal show={clmShow} setShow={setClmShow} />
                                        <Button variant="light" onClick={toggleMute}>
                                            {isMuted && <GoMute />}
                                            {!isMuted && <GoUnmute />}
                                        </Button>
                                    </Container>
                                </Navbar>
                            </Col>
                        </Row>
                    </Col>
                </Container>
                <br />
                <Row style={fadingOut ? { filter: 'blur(2px)' } : undefined}>
                    <Col xs={12}>
                        <div style={{ width: '100%', height: '46.5em' }}>
                            <AlertsTable data={alertTableData} confirmationData={confirmationFilterOptions}
                                         reasonChanged={setReasonChanged} setFadingOut={setFadingOut}
                                         monitoringService={monitoringService}
                                         supportUsers={supportUsers}
                                         handleOnEdit={handleOnEdit} reasons={reasonsArr}
                                         confirmations={confirmations}
                                         setSelectedSystemStates={setSelectedSystemStates}
                                         getAllData={getAllData}
                                         isRequestInProgress={isInitRequestInProgress}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    } else {
        return <Spinner animation="border" variant="primary" />
    }
}
